import React from "react";
import { Link } from "react-router-dom";
import {
  PhoneIcon,
  EnvelopeIcon,
  HeartIcon,
} from "@heroicons/react/24/outline";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="gradient-primary text-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img
                src="/imgs/logo-vert-white.png"
                alt="Ingersoll Built Logo"
                className="h-24"
              />
            </Link>
            <p className="text-gray-200 mb-4">
              Professional carpentry and renovation services with a passion for
              quality craftsmanship.
            </p>
            <div className="text-sm text-gray-300 space-y-1">
              <p>
                <a
                  href="tel:+15551234567"
                  className="hover:text-white transition hover:underline flex items-center gap-2"
                >
                  <PhoneIcon className="w-4 h-4" />
                  (555) 123-4567
                </a>
              </p>
              <p>
                <a
                  href="mailto:info@ingersollbuilt.ca"
                  className="hover:text-white transition hover:underline flex items-center gap-2"
                >
                  <EnvelopeIcon className="w-4 h-4" />
                  info@ingersollbuilt.ca
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-200 hover:text-white transition"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/showcase"
                  className="text-gray-200 hover:text-white transition"
                >
                  Showcase
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-200 hover:text-white transition"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-200">
              <li>Custom Renovations</li>
              <li>Carpentry Work</li>
              <li>Home Improvements</li>
              <li>Deck & Patio Building</li>
              <li>Interior Design</li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4">Business Hours</h4>
            <ul className="space-y-2 text-sm text-gray-200">
              <li>Mon - Fri: 8:00 AM - 5:00 PM</li>
              <li>Weekends: Closed</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-600 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <p className="text-gray-300 text-sm">
              &copy; {currentYear} Ingersoll Built. All rights reserved.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <Link
                to="/privacy-policy"
                className="text-gray-300 hover:text-white transition text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-gray-300 hover:text-white transition text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>

          {/* Credit Line */}
          <div className="border-t border-gray-600 pt-6 text-center">
            <p className="text-gray-400 text-xs flex items-center justify-center gap-1">
              Made with <HeartIcon className="w-3 h-3 text-red-500" /> by{" "}
              <a
                href="https://kennedyportal.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition hover:underline"
              >
                Isaiah
              </a>{" "}
              @{" "}
              <a
                href="https://orbitalsolutions.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition hover:underline"
              >
                Orbital, Inc.
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
